import { useQuery } from "@tanstack/react-query";
import { QUERIES_KEYS } from "queries";
import { courseFinanceReconciliationApi } from "./courseFinanceReconciliationApi";

export const useCourseFinanceReconciliation = (courseId: string | number) => {
  const { isLoading, data } = useQuery({
    queryKey: QUERIES_KEYS.COURSE_FINANCES_RECONCILIATION(courseId),
    queryFn: () => courseFinanceReconciliationApi.fetchReconciliation(courseId),
  });

  return { loading: isLoading, data: data?.data };
};
